import { ChainID } from '@ankr.com/chains-list';

export function prepareChainPathToSharkChain(chain: string) {
  if (chain === ChainID.MULTICHAIN) return 'aapi_v2';

  return chain;
}
